import React from 'react';
import { FeedbackButtonText, Row } from '../FeedbackStyled';
import { ReactComponent as Comment } from '../icons/comment-text.svg';
import { Space } from '@gr-monorepo/common/ui';

function FeedbackButtonOpenContent() {
  return (
    <Row>
      <Comment />
      <Space size={12} axis={'horizontal'} />
      <FeedbackButtonText>Обратная связь</FeedbackButtonText>
    </Row>
  );
}

export default FeedbackButtonOpenContent;
